export const fence = {
    render: 'Fence',
    attributes: {
        language: {
            type: String
        }
    }
};
